import {useHistory, useLocation} from 'react-router-dom';
import {CallSheetRow} from '../../constants/types';
import {convertDateFormat} from './helpers';
import ListOptions from '../common/ListOptions';
import EnsurePermission from '../common/EnsurePermission';
import permissionsInfo from '../../constants/permissionsInfo';
import routes from './routes';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

type RowProps = {
  rowItem: CallSheetRow,
  confirmDelete: () => void}

const DELETE_BUTTON_TOOLTIP_MESSAGE =
  'There is a running process(es) for the call sheet';

const Row = ({rowItem, confirmDelete}: RowProps) => {
  const {pathname, search} = useLocation();
  const history = useHistory();

  const goToCallSheet = () => history.push({
    pathname: routes.item(rowItem?.id),
    state: {callSheetsPathMemo: `${pathname}${search}`}
  });

  const options = {
    EDIT_CALL_SHEET_ROW: {
      name: 'Edit',
      Icon: EditIcon,
      permission: permissionsInfo.calls.edit,
      onClick: goToCallSheet
    },
    DELETE_CALL_SHEET_ROW: {
      name: 'Delete',
      Icon: DeleteIcon,
      disabled: rowItem?.currentlyInUse,
      tooltipMessage: rowItem?.currentlyInUse && DELETE_BUTTON_TOOLTIP_MESSAGE,
      permission: permissionsInfo.calls.delete,
      onClick: () => confirmDelete()
    }};

  return (
    <tr className="call-sheet-row">
      <td
        className="cell cursor-pointer"
        onClick={goToCallSheet}
      >
        {rowItem.id}
      </td>
      <td
        className="cell cursor-pointer"
        onClick={goToCallSheet}
      >
        {rowItem.patientName}
      </td>
      <td
        className="cell cursor-pointer"
        onClick={goToCallSheet}
      >
        {rowItem?.treatmentName}
      </td>
      <td
        className="cell cursor-pointer"
        onClick={goToCallSheet}
      >
        {rowItem?.appointmentDate ?
          convertDateFormat(rowItem.appointmentDate) : ''}
      </td>
      <td
        className="cell cursor-pointer"
        onClick={goToCallSheet}
      >
        {rowItem?.wantsSooner === true ? 'Yes' : ''}
      </td>
      <td
        className="cell cursor-pointer"
        onClick={goToCallSheet}
      >
        {rowItem?.operatoryNumber}
      </td>
      <EnsurePermission elementPermissions={[
        ...permissionsInfo.calls.edit,
        ...permissionsInfo.calls.delete
      ]}>
        <td className="cell narrow-cell">
          <ListOptions options={options} />
        </td>
      </EnsurePermission>
    </tr>
  );
};

export default Row;
